module.exports = __webpack_public_path__ + "img/discod.790d974.png";